import * as React from 'react'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { AxiosResponse } from 'axios'
import { useTranslation } from 'react-i18next'
import { useDownloadFromBlob } from 'utils/useDownloadFromBlob'
import { useGetProposalPdf } from 'vendors/vendorUserRequestForProposals/vendorClosedProposalItem/useDownloadPdfQuery'
import { useSnackbar } from 'snackbar/SnackbarContext'

const ProposalDownloadButton: React.FC<{ proposal: ProposalHistory }> = ({ proposal }) => {
  const { t } = useTranslation()
  const { showSnackbar } = useSnackbar()
  const downloadFromBlob = useDownloadFromBlob()
  const { mutate: downloadProposalPdf, isPending: isFetching } = useGetProposalPdf()

  const handleDownloadProposalPdf = () => {
    downloadProposalPdf(proposal.proposalId, {
      onSuccess: (response: AxiosResponse<string>) => {
        downloadFromBlob(response.data, 'Tarjous', { type: 'application/pdf' })
      },
      onError: (error) => {
        console.error('Failed to download proposal pdf:', error)
        showSnackbar(t('download-error'), 'error')
      }
    })
  }

  return (
    <Button onClick={handleDownloadProposalPdf} disabled={isFetching}>
      <Typography>{t('download-proposal')}</Typography>
    </Button>
  )
}

export default ProposalDownloadButton
